module.exports = __webpack_public_path__ + "img/image-culture-3.affea096.png";